{
    "RangeCombo_Search_Placeholder": "Recherche...",
    "NAME": "RangeComboLanguage",
    "Validation_Generic_Error_Message": "Une ou plusieurs erreurs ont été détectées.",
    "Validation_Generic_Error_Max_Entries": "Vous avez atteint \/ dépassé le nombre maximal d'entrées."
}